import type { Country } from '@sunwebgroup/uds-ui/fields/phone-field'
import type { Locale } from '@/intl/types'
import { countryData } from '@sunwebgroup/uds-ui/fields/phone-field'

export function getDefaultPhoneCountry(locale: Locale): Country {
  const countryCode = locale.split('-')[1]
  return countryData.find(({ isoCode }) => isoCode === countryCode) ?? countryData[0]
}
